/*
 api统一管理
 */
import {get,post} from './axios.js';
import {exportPost} from './export.js';
/*
公共接口
 */
// 获取职业列表
export const getProfessionList=(params)=>{
  return post('/fillmed-club-membership/profession/list',params)
}
// 获取省市区
export const getLocationList=(params)=>{
  return post('/fillmed-club-membership/division/divisionById/list',params)
}
// 获取省市区 树形结构 /fillmed-club-membership/division/divisionTree/list
export const getTreeLocationList=(params)=>{
  return post('/fillmed-club-membership/division/divisionTree/list',params)
}
// 获取品牌列表
export const getBrandList=(params)=>{
  return post('/fillmed-club-basic/base/brand/list',params)
}
// 获取单位列表
export const getUnitList=(params)=>{
  return post('/fillmed-club-basic/base/unit/list',params)
}
// 获取类目(分级次)
export const getTreeCategoryList=(params)=>{
  return post('/fillmed-club-basic/base/treeCategory/list',params)
}
// 上传文件
export const uploadFiles=(params)=>{
  return post('/fillmed-club-basic/base/file/upload',params)
}
// 获取物流公司列表
export const getLogisticsList=(params)=>{
  return post('/fillmed-club-basic/base/express/list',params)
}
// 获取省市区（树形）
export const getLocationTreeList=(params)=>{
  return post('/fillmed-club-membership/division/divisionTree/list',params)
}
// 机构列表
export const getInstitutionsList=(params)=>{
  return post('/fillmed-club-basic/base/agent/list',params)
}
// 登陆
export const userLogin=(params)=>{
  return post('/fillmed-club-auth/user/login',params)
}
// 退出登陆
export const exitLogin=(params)=>{
  return post('/fillmed-club-auth/user/logout',params)
}
// 导入文件
export const importFile=(params)=>{
  return post('/fillmed-club-sell/bloc/branch/upload',params)
}
// 导入模板下载
export const moudleExp=(params)=>{
  return exportPost('/fillmed-club-sell/bloc/branch/template/download',params)
}
/*
会员中心
 */
// 获取会员分页列表
export const getMemberPageList=(params)=>{
  return post('/fillmed-club-membership/member/list',params)
}
// 根据id获取会员详细信息
export const getMemberDetailById=(params)=>{
  return post('/fillmed-club-membership/member/get',params)
}
// 保存会员信息
export const saveMemberInfo=(params)=>{
  return post('/fillmed-club-membership/member/save',params)
}
// 根据id查询会员积分明细
export const getIntegralSubsidiaryById=(params)=>{
  return post('/fillmed-club-membership/member/pointsDetail/list',params)
}
// 根据id查询交易信息明细
export const getTradeInfoById=(params)=>{
  return post('/fillmed-club-membership/member/ordersDetail/list',params)
}
// 修改会员状态
export const changeMemberStatus=(params)=>{
  return post('/fillmed-club-membership/member/changeStatus',params)
}
// 会员导出
export const memberExp=(params)=>{
  return exportPost('/fillmed-club-membership/member/export',params)
}
/*
商品中心
 */
// 添加商品
export const addProduct=(params)=>{
  return post('/fillmed-club-commodity/sku/add',params)
}
// 获取商品列表
export const getProductList=(params)=>{
  return post('/fillmed-club-commodity/sku/list',params)
}
// 获取商品详情
export const getProductDetailById=(params)=>{
  return post('/fillmed-club-commodity/sku/findById/get',params)
}
// 更新商品详情
export const updateProduct=(params)=>{
  return post('/fillmed-club-commodity/sku/save',params)
}
// 修改上下架状态
export const changeStatus=(params)=>{
  return post('/fillmed-club-commodity/sku/changeStatus/save',params)
}
// 批量上下架
export const batchChangeStatus=(params)=>{
  return post('/fillmed-club-commodity/sku/changeStatus/batchSave',params)
}
/*
 内容中心
 */
// 获取文章列表
export const getArticlePageList=(params)=>{
  return post('/fillmed-club-basic/article/list',params)
}
// 新增文章
export const addArticle=(params)=>{
  return post('/fillmed-club-basic/article/add',params)
}
// 删除文章
export const delArticle=(params)=>{
  return post('/fillmed-club-basic/article/delete',params)
}
// 获取文章详情
export const getArticleDetail=(params)=>{
  return post('/fillmed-club-basic/article/get',params)
}
// 更新文章详情
export const updateArticle=(params)=>{
  return post('/fillmed-club-basic/article/save',params)
}
// 获取栏位列表
export const getColumnPageList=(params)=>{
  return post('/fillmed-club-basic/contentcenter/position/list',params)
}
// 新增栏位
export const addColumn=(params)=>{
  return post('/fillmed-club-basic/contentcenter/position/add',params)
}
// 获取栏位详情
export const getColumnDetail=(params)=>{
  return post('/fillmed-club-basic/contentcenter/position/get',params)
}
// 修改栏位
export const updateColumn=(params)=>{
  return post('/fillmed-club-basic/contentcenter/position/set',params)
}
// 更改栏位状态
export const changeColumnStatus=(params)=>{
  return post('/fillmed-club-basic/contentcenter/position/changeStatus',params)
}
// 获取素材列表
export const materialPageList=(params)=>{
  return post('/fillmed-club-basic/contentcenter/material/list',params)
}
// 新增素材
export const addMaterial=(params)=>{
  return post('/fillmed-club-basic/contentcenter/material/add',params)
}
// 删除素材
export const delMaterial=(params)=>{
  return post('/fillmed-club-basic/contentcenter/material/delete',params)
}
// 获取素材详情
export const getMaterialDetail=(params)=>{
  return post('/fillmed-club-basic/contentcenter/material/get',params)
}
// 更新素材
export const updateMaterialDetail=(params)=>{
  return post('/fillmed-club-basic/contentcenter/material/update',params)
}
// 修改素材状态
export const changeMaterialStatus=(params)=>{
  return post('/fillmed-club-basic/contentcenter/material/status',params)
}
/*
 规则管理
 */
// 获取积分调整列表
export const getIntegralAdjustPageList=(params)=>{
  return post('/fillmed-club-membership/member/Adjustment/list',params)
}
// 新增积分调整
export const addIntegralAdjust=(params)=>{
  return post('/fillmed-club-membership/member/Adjustment/set',params)
}
// 积分规则列表
export const getIntegralRulesPageList=(params)=>{
  return post('/fillmed-club-basic/rule/list',params)
}
// 添加签到积分规则
export const addSignInRules=(params)=>{
  return post('/fillmed-club-basic/rule/sign/add',params)
}
// 获取签到积分规则详情
export const getSignInRulesDetail=(params)=>{
  return post('/fillmed-club-basic/rule/sign/get',params)
}
// 更新签到积分规则
export const updateSignInRules=(params)=>{
  return post('/fillmed-club-basic/rule/sign/set',params)
}
// 添加扫码积分规则
export const addScanCodeRules=(params)=>{
  return post('/fillmed-club-basic/rule/scan/add',params)
}
// 获取扫码积分规则详情
export const getScanCodeRulesDetail=(params)=>{
  return post('/fillmed-club-basic/rule/scan/get',params)
}
// 更新扫码积分规则
export const updateScanCodeRules=(params)=>{
  return post('/fillmed-club-basic/rule/scan/set',params)
}
// 添加邀新规则
export const addInviteNewRules=(params)=>{
  return post('/fillmed-club-basic/rule/share/add',params)
}
// 获取邀新规则详情
export const getInviteNewRulesDetail=(params)=>{
  return post('/fillmed-club-basic/rule/share/get',params)
}
// 更新邀新规则
export const updateInviteNewRules=(params)=>{
  return post('/fillmed-club-basic/rule/share/set',params)
}
// 添加积分清零、临期提醒积分规则
export const addExpireIntegralRules=(params)=>{
  return post('/fillmed-club-basic/rule/expire/add',params)
}
// 获取积分清零、临期提醒积分规则详情
export const getExpireIntegralRulesDetail=(params)=>{
  return post('/fillmed-club-basic/rule/expire/get',params)
}
// 更新积分清零、临期提醒积分规则
export const updateExpireIntegralRules=(params)=>{
  return post('/fillmed-club-basic/rule/expire/set',params)
}
// 添加保存完善信息积分规则
export const addPerfectInfoRules=(params)=>{
  return post('/fillmed-club-basic/rule/Info/add',params)
}
// 获取保存完善信息积分规则详情
export const getPerfectInfoRulesDetail=(params)=>{
  return post('/fillmed-club-basic/rule/Info/get',params)
}
// 更新保存完善信息积分规则
export const updatePerfectInfoRules=(params)=>{
  return post('/fillmed-club-basic/rule/Info/set',params)
}
// 获取扫码商品列表
export const getScanCode=(params)=>{
  return post('/fillmed-club-basic/base/product/list',params)
}
// 启用停用积分规则
export const setStatus=(params)=>{
  return post('/fillmed-club-basic/rule/status/set',params)
}
// 会员等级列表
export const getMemberLevelList=(params)=>{
  return post('/fillmed-club-membership/grade/list',params)
}
// 新增会员等级
export const addMemberLevel=(params)=>{
  return post('/fillmed-club-membership/grade/save',params)
}
// 获取会员等级详情
export const getMemberLevelDetail=(params)=>{
  return post('/fillmed-club-membership/grade/get',params)
}
// 编辑会员等级
export const updateMemberLevel=(params)=>{
  return post('/fillmed-club-membership/grade/set',params)
}
/*
 订单中心
 */
// 获取订单列表
export const getOrderPageList=(params)=>{
  return post('/fillmed-club-commodity/order/list',params)
}
// 获取订单详情
export const getOrderDetail=(params)=>{
  return post('/fillmed-club-commodity/order/get',params)
}
// 发货
export const orderDelivery=(params)=>{
  return post('/fillmed-club-commodity/order/express/set',params)
}
// 订单导出
export const orderExport=(params)=>{
  return exportPost('/fillmed-club-commodity/order/export',params)
}
// 确认收货
export const confirmReceipt=(params)=>{
  return post('/fillmed-club-commodity/order/orderStatus',params)
}
// 导入快递单号
export const importExpress=(params)=>{
  return post('/fillmed-club-commodity/order/shipping/upload',params)
}
/*
营销中心
 */
// 获取促活分页列表
export const getPromotePageList=(params)=>{
  return post('/fillmed-club-basic/activity/query',params)
}
// 新增促活
export const addPromote=(params)=>{
  return post('/fillmed-club-basic/activity/add',params)
}
// 获取促活详情
export const getPromoteDetail=(params)=>{
  return post('/fillmed-club-basic/activity/get',params)
}
// 更新促活
export const updatePromote=(params)=>{
  return post('/fillmed-club-basic/activity/update',params)
}
// 手工关闭活动
export const manualClosePromote=(params)=>{
  return post('/fillmed-club-basic/activity/changeStatus',params)
}
// 获取拉新分页列表
export const getPullNewPageList=(params)=>{
  return post('/fillmed-club-basic/newactivity/query',params)
}
// 新增拉新活动
export const addPullNew=(params)=>{
  return post('/fillmed-club-basic/newactivity/add',params)
}
// 获取拉新详情
export const getPullNewDetail=(params)=>{
  return post('/fillmed-club-basic/newactivity/get',params)
}
// 更新拉新
export const updatePullNew=(params)=>{
  return post('/fillmed-club-basic/newactivity/update',params)
}
// 开启/关闭拉新活动
export const switchPullNew=(params)=>{
  return post('/fillmed-club-basic/activity/switch',params)
}
/* 
销售管理 
 */
// 实销数据管理
export const getSolidPinDataPageList=(params)=>{
  return post('/fillmed-club-sell/detail/page',params)
}
// 获取集团列表
export const getGroupList=(params)=>{
  return post('/fillmed-club-sell/bloc/list',params)
}
// 获取机构列表
export const getOrgList=(params)=>{
  return post('/fillmed-club-sell/bloc/branch/list',params)
}
// 获取机构分页列表
export const getOrgPageList=(params)=>{
  return post('/fillmed-club-sell/bloc/branch/page',params)
}
// 删除机构 /fillmed-club-sell/bloc/branch/delete post
export const deleteBranch=(params)=>{
  return post('/fillmed-club-sell/bloc/branch/delete',params)
}
// 获取机构详情
export const getOrgDetail=(params)=>{
  return post('/fillmed-club-sell/bloc/branch/get',params)
}
// 获取科室列表
export const getDepartmentList=(params)=>{
  return post('/fillmed-club-sell/department/list',params)
}
// 全部科室 /fillmed-club-sell/department/all get
export const getDepartmentAllList=(params)=>{
  return post('/fillmed-club-sell/department/all',params)
}
// 全部产品 /fillmed-club-sell/product/all get
export const getProductAllList=(params)=>{
  return post('/fillmed-club-sell/product/all',params)
}
// 获取主打产品列表
export const getMainProductList=(params)=>{
  return post('/fillmed-club-sell/product/list',params)
}
// 获取各种政策
export const getPolicy=(params)=>{
  return post('/fillmed-club-sell/policy/list',params)
}
// 获取销售代表列表
export const getSalesRepresentativeList=(params)=>{
  return post('/fillmed-club-sell/bloc/employee/list',params)
}
// 获取销售代表/地区经理 /fillmed-club-sell/bloc/employee/empList post params:type  1.经理，2.代表
export const getEmployeeList=(params)=>{
  return post('/fillmed-club-sell/bloc/employee/empList',params)
}
// 导出机构信息
export const branchExport=(params)=>{
  return exportPost('/fillmed-club-sell/bloc/branch/export',params)
}
// 导出 实销信息 
export const detailExport=(params)=>{
  return exportPost('/fillmed-club-sell/detail/export',params)
}
// 编辑机构信息保存 
export const updateBranch=(params)=>{
  return post('/fillmed-club-sell/bloc/branch/set',params)
}



// WEBPACK FOOTER //
// ./src/api/api.js